import axios from 'axios';

axios.defaults.withCredentials = true;

export const authenticateUser = (username, password) => axios.post( '/users/authenticate', { username : username, password : password})

export const loginState = () => axios.post( '/users/loginstate');

export const endSession = () => axios.post( '/users/logout');